import { render, staticRenderFns } from "./MWhitePrice.vue?vue&type=template&id=121455e9&scoped=true"
import script from "./MWhitePrice.vue?vue&type=script&lang=js"
export * from "./MWhitePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121455e9",
  null
  
)

export default component.exports